/* eslint-disable id-length */
import { useEffect, useMemo } from "react";
import LineChart, { LineChartUnit } from "~/components/ClustersInsights/LineChart";
import { colorsForIndex } from "~/components/ClustersInsights/Theme";
import { useChart } from "~/components/shared/Chart/chart";
import { Series } from "~/components/job/Job/HostedCompute/types";
import {
  chartOptionsOverride,
  convertToChartDatasets,
  tooltipValueFormat,
} from "~/components/job/Job/HostedCompute/common";

interface PercentageComputeChartProps {
  chartData: Series;
}

export const PercentageComputeChart = (props: PercentageComputeChartProps) => {
  const { chartRef, updateData } = useChart<"line", number>();

  const data = useMemo(
    () => ({
      labels: props.chartData.timestamps,
      datasets: convertToChartDatasets(props.chartData).map((dataset, index) => ({
        ...dataset,
        ...colorsForIndex(index),
      })),
    }),
    [props.chartData],
  );

  useEffect(() => {
    updateData(data);
  }, [data, updateData]);

  return (
    <LineChart
      ref={chartRef}
      data={data}
      units={{ y: LineChartUnit.percentage }}
      options={chartOptionsOverride(tooltipValueFormat((value) => `${Math.round(value)}%`))}
    />
  );
};
